<ng-template #filterWrapper>
  @if (isOpen) {
  <div [ngClass]="inlineFilter ? 'inline-filter-panel' : 'filter-panel'"
    #filterContainer
    tabindex="-1"
    (keyup)="handleFilterContainerKeyUp($event)">
    <!-- Header -->
    @if (filterContentHeaderTitle || customTitle) {
    <div class="panel-header">
      @if (customTitle) {
      <ng-container [ngTemplateOutlet]="customTitle"
        [ngTemplateOutletContext]="headerDefinitions" />
      } @else {
      <h3 class="panel-title">{{ headerDefinitions.title }}</h3>
      }
    </div>
    }

    <!-- Search -->
    @if (false && searchable) {
    <div class="search-section">
      @if (customSearchInput) {
      <ng-container [ngTemplateOutlet]="customSearchInput"
        [ngTemplateOutletContext]="{ query: draftSearchQuery, onChange: onSearchInput }" />
      } @else {
      <div class="search-wrapper">
        <input type="text"
          class="search-input"
          [placeholder]="searchPlaceholder"
          [ngModel]="draftSearchQuery"
          (input)="onSearchInput($event)">
        <i class="i-vi-search"></i>
      </div>
      }
    </div>
    }

    <!-- Content -->
    <div class="panel-content">
      <vi-ui-scroll-list [items]="items"
        [isLoading]="isLoading"
        [hasMore]="hasMore"
        [itemSize]="itemSize"
        [isVirtualScrollActive]="isVirtualScrollActive"
        [minBufferPx]="minBufferPx"
        [maxBufferPx]="maxBufferPx"
        (loadMore)="onLoadMoreItems()">
        <ng-template let-item
          let-index="index"
          let-first="first"
          let-last="last"
          let-even="even"
          let-odd="odd"
          #itemTemplate>
          <ng-container [ngTemplateOutlet]="filterContent"
            [ngTemplateOutletContext]="{
              item: getItemContext(item.id),
              index: index,
              isFirst: first,
              isLast: last,
              isEven: even,
              isOdd: odd,
            }" />
        </ng-template>
        @if (emptyState) {
        <ng-template #emptyListTemplate>
          <ng-container [ngTemplateOutlet]="emptyState" />
        </ng-template>
        }
        @if (loadingMoreState) {
        <ng-template #loadingMoreTemplate>
          <ng-container [ngTemplateOutlet]="loadingMoreState" />
        </ng-template>
        }
        @if (loadingState) {
        <ng-template #shimmerTemplate>
          <ng-container [ngTemplateOutlet]="loadingState" />
        </ng-template>
        }
      </vi-ui-scroll-list>
    </div>


    <!-- Action buttons -->
    @if (!inlineFilter) {
    <div class="panel-actions">
      @if (customBottomSection) {
      <ng-container [ngTemplateOutlet]="customBottomSection"
        [ngTemplateOutletContext]="bottomSectionDefinitions" />
      } @else {
      <div class="action-buttons">
        @if (shouldShowApplyButton) {
        @if (customApplyButton) {
        <ng-container [ngTemplateOutlet]="customApplyButton"
          [ngTemplateOutletContext]="{
            label: bottomSectionDefinitions.applyButtonLabel,
            isButtonDisabled: bottomSectionDefinitions.isApplyDisabled,
            onCLick: bottomSectionDefinitions.applyFilter,
            hasFilters: bottomSectionDefinitions.hasFilters,
            draftSelectedFilters: bottomSectionDefinitions.draftSelectedFilters
             }" />
        } @else {
        <button class="btn-apply"
          (click)="bottomSectionDefinitions.applyFilter()"
          [class.focused]="isActionFocused('apply')"
          [disabled]="bottomSectionDefinitions.isApplyDisabled">
          {{bottomSectionDefinitions.applyButtonLabel}}
          @if (bottomSectionDefinitions.hasFilters && bottomSectionDefinitions.isVisible) {
          <span class="apply-count">({{bottomSectionDefinitions.draftSelectedFilters}})</span>
          }
        </button>
        }
        }

        @if (shouldShowClearButton) {
        @if (customClearButton) {
        <ng-container [ngTemplateOutlet]="customClearButton"
          [ngTemplateOutletContext]="{
            label: bottomSectionDefinitions.clearButtonLabel,
            isButtonDisabled: bottomSectionDefinitions.isClearDisabled,
            onCLick: bottomSectionDefinitions.clearFilter,
            hasFilters: bottomSectionDefinitions.hasFilters,
            draftSelectedFilters: bottomSectionDefinitions.draftSelectedFilters
             }" />
        } @else {
        <button class="btn-clear"
          (click)="bottomSectionDefinitions.clearFilter()"
          [class.focused]="isActionFocused('clear')"
          [disabled]="bottomSectionDefinitions.isClearDisabled">
          {{bottomSectionDefinitions.clearButtonLabel}}
        </button>
        }
        }

        @if (shouldShowClearAllButton) {
        @if (customClearAllButton) {
        <ng-container [ngTemplateOutlet]="customClearAllButton"
          [ngTemplateOutletContext]="{
            label: bottomSectionDefinitions.clearAllButtonLabel,
            isButtonDisabled: bottomSectionDefinitions.isClearAllDisabled,
            onCLick: bottomSectionDefinitions.clearAllFilters,
            hasFilters: bottomSectionDefinitions.hasFilters,
            draftSelectedFilters: bottomSectionDefinitions.draftSelectedFilters
             }" />
        } @else {
        <button class="btn-clear-all"
          (click)="bottomSectionDefinitions.clearAllFilters()"
          [class.focused]="isActionFocused('clearAll')"
          [disabled]="bottomSectionDefinitions.isClearAllDisabled">
          {{bottomSectionDefinitions.clearAllButtonLabel}}
        </button>
        }
        }
      </div>
      }
    </div>
    }
  </div>
  }
</ng-template>

<div class="filter-container">
  <div class="filter-action"
    #filterButton>
    @if (customFilterActionButton) {
    <ng-container [ngTemplateOutlet]="customFilterActionButton"
      [ngTemplateOutletContext]="filterActionButtonDefinitions" />
    } @else {
    <button class="filter-btn"
      (viUiAccessibleClick)="filterActionButtonDefinitions.toggleFilter()"
      [appSpaceClickEnabled]="true"
      [class.active]="filterActionButtonDefinitions.isOpen"
      [class.has-filters]="filterActionButtonDefinitions.hasFilters">
      {{ filterTitle }}
      @if (filterActionButtonDefinitions.hasFilters && filterActionButtonDefinitions.isVisible) {
      <span class="filter-count">({{ appliedFilters.length }})</span>
      }
      <i class="filter-arrow-icon"
        [ngClass]="filterActionButtonDefinitions.isOpen ? 'is-open i-vi-arrow-up-small' : 'i-vi-arrow-down-small'"></i>
    </button>
    }
  </div>
  @if (!inlineFilter) {
  <ng-container [ngTemplateOutlet]="filterWrapper">
  </ng-container>
  }
</div>

@if (inlineFilter) {
<ng-container [ngTemplateOutlet]="filterWrapper">
</ng-container>
}